import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { ThemedText } from '../../ThemedComponents';
import { BackupMethodRadioList } from './BackupMethodRadioList';

/**
 * Body of the redesigned "Backup method" step.
 */
export const BackupMethodBody: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box direction="vertical" width="100%" gap={2}>
      <ThemedText>
        {t('wixAppEnforcement.addOwnerApp.wizard.backupMethod.label')}
      </ThemedText>
      <BackupMethodRadioList />
    </Box>
  );
};
